// Erişim kaydı hata eşlemesi (portal yetki v2) — çekmece ve danışman editörü ortak. Sunucu
// sözleşmesi: 409 KPI_ACCESS_STALE (iyimser jeton; sessiz yeniden deneme YOK — güncel hali yükle),
// 409 KPI_ACCESS_BUSY, 403 CLIENT_ADMIN_SCOPE_EXCEEDED (`details.dimension`), 422 doğrulama kodları.
// Kimlik (`details.ids`) asla yazdırılmaz.

import { ApiError } from "../api/client";
import { CLIENT_ACCESS_ERROR_COPY as E } from "./client-admin-copy";

export interface AccessErrorInfo {
  text: string;
  /** Güncel hali yeniden yüklenmeli (409 STALE). */
  reload: boolean;
}

export function scopeDimension(err: unknown): string | null {
  if (!(err instanceof ApiError) || err.code !== "CLIENT_ADMIN_SCOPE_EXCEEDED") return null;
  const d = err.details;
  if (d && typeof d === "object" && "dimension" in d) {
    const v = (d as { dimension?: unknown }).dimension;
    return typeof v === "string" ? v : null;
  }
  return null;
}

export function describeAccessError(err: unknown, fallback: string = E.generic): AccessErrorInfo {
  if (!(err instanceof ApiError)) return { text: fallback, reload: false };
  if (err.code === "KPI_ACCESS_STALE") return { text: E.stale, reload: true };
  if (err.code === "KPI_ACCESS_BUSY") return { text: E.busy, reload: false };
  if (err.code === "CLIENT_ADMIN_SCOPE_EXCEEDED") {
    const dim = scopeDimension(err);
    return { text: (dim ? E.scope[dim] : undefined) ?? E.scopeFallback, reload: false };
  }
  return { text: E.codes[err.code] ?? fallback, reload: false };
}
